import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">影视分类</h2>
          <p className="text-foreground-600 text-sm">按分类浏览，快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">{item.name}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-medium text-primary-500">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}